<template>
    <section class="department-item">
        <div class="row">
            <div class="col grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 v-if="$attrs.mode === 'new'">{{ $t('createNewTitle') }}</h4>
                        <h4 v-else class="card-title">{{ $t('editEntry') }} <strong>{{departmentName}}</strong> <code>(id {{department.id}})</code></h4>
                        <p class="card-description pb-4">{{ $t('fillFieldsBelow') }}</p>
                        <div class="forms-sample">
                            <div class="row">
                                <div class="col-lg-6">
                                    <b-form-group :label="$t('forms.name')" label-for="name-input">
                                        <b-form-input type="text" id="name-input" :placeholder="$t('forms.name')" v-model="department.name" :state="nameState"/>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-6">
                                    <b-form-group label="URL" label-for="url-input">
                                        <b-form-input type="text" id="url-input" placeholder="URL" v-model="department.url" :state="urlState"/>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6">
                                    <b-form-group :label="$t('forms.city')" label-for="city-input" class="mb-4">
                                        <div class="row align-items-center">
                                            <div class="col-auto text-right min-45px-w">{{ lang.toUpperCase() }}:</div>
                                            <div class="col"><b-form-input type="text" id="city-input" :placeholder="$t('forms.city') + ' (' + lang.toUpperCase() + ')'" v-model="department.city" :state="cityState"/></div>
                                        </div>
                                        <div class="row align-items-center mt-1">
                                            <div class="col-auto text-right min-45px-w">EN:</div>
                                            <div class="col"><b-form-input type="text" id="cityEn-input" :placeholder="$t('forms.city') + ' (EN)'" v-model="department.cityEn" :state="cityEnState"/></div>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-6">
                                    <b-form-group :label="$t('forms.openHours')" label-for="openHours-input" class="mb-4">
                                        <div class="row align-items-center">
                                            <div class="col-auto text-right min-45px-w">{{ lang.toUpperCase() }}:</div>
                                            <div class="col"><b-form-input type="text" id="openHours-input" :placeholder="$t('forms.openHours') + ' (' + lang.toUpperCase() + ')'" v-model="department.open"/></div>
                                        </div>
                                        <div class="row align-items-center mt-1">
                                            <div class="col-auto text-right min-45px-w">EN:</div>
                                            <div class="col"><b-form-input type="text" id="openHoursEn-input" :placeholder="$t('forms.openHours') + ' (EN)'" v-model="department.openEn"/></div>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                            <b-form-group :label="$t('forms.title')" label-for="title-input" class="mb-4">
                                <div class="row align-items-center">
                                    <div class="col-auto text-right min-45px-w">{{ lang.toUpperCase() }}:</div>
                                    <div class="col"><b-form-input type="text" id="title-input" :placeholder="$t('forms.title') + ' (' + lang.toUpperCase() + ')'" v-model="department.title" :state="titleState"/></div>
                                </div>
                                <div class="row align-items-center mt-1">
                                    <div class="col-auto text-right min-45px-w">EN:</div>
                                    <div class="col"><b-form-input type="text" id="titleEn-input" :placeholder="$t('forms.title') + ' (EN)'" v-model="department.titleEn" :state="titleEnState"/></div>
                                </div>
                            </b-form-group>

                            <b-form-group :label="$t('forms.description')" label-for="description-input" class="mb-4">
                                <div class="row align-items-center">
                                    <div class="col-auto text-right min-45px-w">{{ lang.toUpperCase() }}:</div>
                                    <div class="col"><b-form-input type="text" id="description-input" :placeholder="$t('forms.description') + ' (' + lang.toUpperCase() + ')'" v-model="department.description" :state="descriptionState"/></div>
                                </div>
                                <div class="row align-items-center mt-1">
                                    <div class="col-auto text-right min-45px-w">EN:</div>
                                    <div class="col"><b-form-input type="text" id="descriptionEn-input" :placeholder="$t('forms.description') + ' (EN)'" v-model="department.descriptionEn" :state="descriptionEnState"/></div>
                                </div>
                            </b-form-group>

                            <div class="row">
                                <div class="col-lg-6">
                                    <b-form-group :label="$t('forms.address')" label-for="address-input">
                                        <b-form-input type="text" id="address-input" :placeholder="$t('forms.address')" v-model="department.address" :state="addressState"/>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-6">
                                    <b-form-group :label="$t('forms.addressExt')" label-for="address2-input">
                                        <b-form-input type="text" id="address2-input" :placeholder="$t('forms.addressExt')" v-model="department.addressNextLine"/>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.postal')" label-for="postal-input">
                                        <b-form-input type="text" id="postal-input" :placeholder="$t('forms.postal')" v-model="department.postal"/>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.longitude')" label-for="xcor-input">
                                        <b-form-input type="number" id="xcor-input" :placeholder="$t('forms.longitude')" v-model="department.xcoordinate" :state="xState"/>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.latitude')" label-for="ycor-input">
                                        <b-form-input type="number" step="any" id="ycor-input" :placeholder="$t('forms.latitude')" v-model="department.ycoordinate" :state="yState"/>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.order')" label-for="order-input">
                                        <b-form-input type="number" step="any" id="order-input" :placeholder="$t('forms.order')" v-model="department.itemOrder" :state="orderState" min="1"/>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.email')" label-for="email-input">
                                        <b-form-input type="text" id="email-input" :placeholder="$t('forms.email')" v-model="department.email"/>
                                    </b-form-group>
                                </div>
                            </div>

                            <b-form-group :label="$t('forms.description') + ' (' + lang.toUpperCase() + ')'" label-for="tinymce-input">
                                <editor ref="formEditor" id="tinymce-input" :api-key="editorApiKey" :init="editorConf" v-model="department.summary"/>
                            </b-form-group>

                            <b-form-group :label="$t('forms.description') + ' (EN)'" label-for="tinymceEn-input">
                                <editor ref="formEditorEn" id="tinymceEn-input" :api-key="editorApiKey" :init="editorConfEn" v-model="department.summaryEn"/>
                            </b-form-group>

                            <b-button variant="success" class="mr-2" @click="saveItem" :disabled="validated">{{ $t('forms.save') }}</b-button>
                            <b-button variant="light" v-on:click="cancel">{{ $t('forms.cancel') }}</b-button>
                            <b-button v-if="$attrs.mode === 'edit'" variant="danger" class="float-right" v-b-modal.confirm-delete>{{ $t('forms.delete') }}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="confirm-delete" :title="$t('forms.warning')" size="md" header-bg-variant="danger" header-text-variant="light" :cancelTitle="$t('forms.cancel')" :okTitle="$t('forms.delete')" @ok="deleteItem">
            <p class="text-center">{{ $t('forms.deleteConfirmationMessage') }}</p>
        </b-modal>

        <b-modal id="image-picker" :title="$t('forms.imagePickerTitle')" size="xl" header-bg-variant="primary" header-text-variant="light" :okTitle="$t('forms.close')" ok-only>
            <div class="row images">
                <div class="col-lg-1 my-auto text-center p-1" v-for="image in images" :key="image.id" :id="'image-wrapper-' + image.id">
                    <img :id="image.id" :src="image.filename" :alt="image.alt" class="browser-image" @click="pasteImage(image.id)">
                    <b-popover :target="'image-wrapper-' + image.id" triggers="hover" placement="top">
                        <div class="row">
                            <div class="col text-center">
                                <span><em>{{image.filename.substr(8)}}</em></span><br>
                                <span class="p-0">{{image.width + ' x ' + image.height}}</span>
                            </div>
                        </div>
                    </b-popover>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../main'
    var Editor = require('@tinymce/tinymce-vue').default;
    var app = null

    export default {
        name: 'Department',
        components: {
            'editor': Editor
        },
        computed: {
            nameState() {
                if (this.department.name) {
                    return this.department.name.length > 0
                } else {
                    return false
                }
            },
            titleState() {
                if (this.department.title) {
                    return this.department.title.length > 0
                } else {
                    return false
                }
            },
            titleEnState() {
                if (this.department.titleEn) {
                    return this.department.titleEn.length > 0
                } else {
                    return false
                }
            },
            descriptionState() {
                if (this.department.description) {
                    return this.department.description.length > 0
                } else {
                    return false
                }
            },
            descriptionEnState() {
                if (this.department.descriptionEn) {
                    return this.department.descriptionEn.length > 0
                } else {
                    return false
                }
            },
            urlState() {
                if (this.department.url) {
                    return this.department.url.length > 0 &&
                        this.department.url.startsWith('/') &&
                        this.department.url.split('/').length === 2
                } else {
                    return false
                }
            },
            cityState() {
                if (this.department.city) {
                    return this.department.city.length > 0
                } else {
                    return false
                }
            },
            cityEnState() {
                if (this.department.cityEn) {
                    return this.department.cityEn.length > 0
                } else {
                    return false
                }
            },
            addressState() {
                if (this.department.address) {
                    return this.department.address.length > 0
                } else {
                    return false
                }
            },
            xState() {
                if (this.department.xcoordinate) {
                    return this.department.xcoordinate > 0
                } else {
                    return false
                }
            },
            yState() {
                if (this.department.ycoordinate) {
                    return this.department.ycoordinate > 0
                } else {
                    return false
                }
            },
            orderState() {
                if (this.department.itemOrder) {
                    return this.department.itemOrder > 0
                } else {
                    return false
                }
            },
            validated() {
                return !this.nameState || !this.titleState || !this.titleEnState || !this.descriptionState ||
                    !this.descriptionEnState || !this.urlState || !this.cityState || !this.cityEnState ||
                    !this.addressState || !this.xState || !this.yState || !this.orderState
            }
        },
        data() {
            return {
                lang: Const.LANG,
                images: [],
                department: {},
                departmentName: '',
                editorApiKey: "jdsjwlv71ngv4ngm4fca30grz3lu6w833qma1br216ewfsqh",
                editorConf: {
                    language: Const.LANG,
                    min_height: 500,
                    menubar: false,
                    convert_urls: false,
                    toolbar_sticky: true,
                    plugins: [
                        'lists link image paste wordcount code autoresize'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link customImage | code',
                    block_formats: 'Paragraph=p; Heading 2=h2; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6',
                    contextmenu: "link image imagetools table",
                    autoresize_bottom_margin: 100,
                    placeholder: this.$t('forms.writeHere'),
                    setup: function (editor) {
                        editor.ui.registry.addButton('customImage', {
                            icon: 'image',
                            onAction: () => app.openImagePicker('tinymce-input')
                        });
                    }
                },
                editorConfEn: {
                    language: 'en',
                    min_height: 500,
                    menubar: false,
                    convert_urls: false,
                    toolbar_sticky: true,
                    plugins: [
                        'lists link image paste wordcount code autoresize'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link customImage | code',
                    block_formats: 'Paragraph=p; Heading 2=h2; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6',
                    contextmenu: "link image imagetools table",
                    autoresize_bottom_margin: 100,
                    placeholder: this.$t('forms.writeHere'),
                    setup: function (editor) {
                        editor.ui.registry.addButton('customImage', {
                            icon: 'image',
                            onAction: () => app.openImagePicker('tinymceEn-input')
                        });
                    }
                },
                imagePickerContext: ''
            }
        },
        mounted() {
            app = this
            if (this.$attrs.mode === Const.MODE_EDIT) {
                axios.get(Const.API_HOST + '/admin/department/get', {
                    params: {
                        'id': this.$route.params.id
                    }
                }).then(function (response) {
                    return response.data
                }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                }).then(body => {
                    this.department = body
                    this.departmentName = JSON.parse(JSON.stringify(this.department.name))
                })
            } else {
                this.department = {
                    name: '',
                    title: '',
                    titleEn: '',
                    description: '',
                    descriptionEn: '',
                    city: '',
                    cityEn: '',
                    address: '',
                    addressNextLine: '',
                    postal: '',
                    email: '',
                    open: '',
                    openEn: '',
                    summary: '',
                    summaryEn: '',
                    xcoordinate: '',
                    ycoordinate: '',
                    url: '',
                    itemOrder: ''
                }
            }
        },
        methods: {
            cancel() {
                this.$router.push('/departments')
            },
            saveItem() {
                var app = this
                axios.post(Const.API_HOST + '/admin/department/save', {
                    department: {
                        id: this.department.id,
                        name: this.department.name,
                        title: this.department.title,
                        titleEn: this.department.titleEn,
                        description: this.department.description,
                        descriptionEn: this.department.descriptionEn,
                        city: this.department.city,
                        cityEn: this.department.cityEn,
                        address: this.department.address,
                        addressNextLine: this.department.addressNextLine,
                        postal: this.department.postal,
                        email: this.department.email,
                        open: this.department.open,
                        openEn: this.department.openEn,
                        summary: this.department.summary,
                        summaryEn: this.department.summaryEn,
                        xcoordinate: this.department.xcoordinate,
                        ycoordinate: this.department.ycoordinate,
                        url: this.department.url,
                        itemOrder: this.department.itemOrder
                    }
                }).then(function (response) {
                    // eslint-disable-next-line no-console
                    console.log(response)
                    if (response.status === 200) {
                        app.$router.push('/departments')
                    }
                }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
            },
            deleteItem() {
                var app = this
                axios.delete(Const.API_HOST + '/admin/department/delete', {
                    data: {
                        id: this.department.id
                    }
                }).then(function (response) {
                    // eslint-disable-next-line no-console
                    console.log(response)
                    if (response.status === 200) {
                        app.$router.push('/departments')
                    }
                }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
            },
            openImagePicker(context) {
                this.imagePickerContext = context
                this.$bvModal.show('image-picker')
                axios.get(Const.API_HOST + '/admin/images')
                    .then(function (response) {
                        return response.data
                    }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                }).then(body => {
                    this.images = body
                })
            },
            pasteImage(id) {
                var selected = this.images.find(obj => {
                    return obj.id === id
                })

                // eslint-disable-next-line no-console
                console.log(selected.filename)
                var html = '<p class="par-with-images"><img src="' + selected.filename + '" alt="' + selected.alt + '"></p>'

                if (this.imagePickerContext === 'tinymce-input') {
                    this.$refs.formEditor.editor.execCommand('mceInsertContent', false, html);
                } else if (this.imagePickerContext === 'tinymceEn-input') {
                    this.$refs.formEditorEn.editor.execCommand('mceInsertContent', false, html);
                }

                this.$bvModal.hide('image-picker')
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

    .browser-image {
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
    }

    /deep/ .tox-editor-container div:first-child {
        top: 58px !important;
    }
</style>
